import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';

@Component
export default class GoBackArrow extends Vue {
    public title: string = 'GoBackArrow';
    public configs = new CommonConfig();

    @Prop({ default: '#fff' })
    public colorHex!: string;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
    public goBack() {
        this.$router.go(-1);
    }
}
